<template>
  <div>
    <div style="text-align: center">
      <md-button
        v-if="isInCurrentState('SHOW_DETALHE')"
        class="md-primary md-raised"
        @click="sairDetalhe"
      >
        Voltar
      </md-button>

      <div v-if="isInCurrentState('SHOW_HISTORICO')">
        <md-button class="md-primary md-raised" @click="historicoToDetalhe">
          Voltar
        </md-button>
      </div>
      <md-divider />
    </div>
    <br />
    <div v-if="isInCurrentState('SHOW_HISTORICO')">
      <historico-pontos-sig :ponto-id="ponto.id" />
    </div>
    <div v-if="isInCurrentState('CREATE')">
      <formulario-ponto-sig
        :local-id="ponto.localId"
        :localizacao="ponto.localizacao"
        :ponto-sig-id="ponto.id"
        :dados-associados="ponto.dadosAssociados"
        @clickCancelar="createToDetalhe"
        @submit="handleFormularioSubmit"
      />
    </div>
    <div v-if="isInCurrentState('SHOW_DETALHE')">
      <md-card>
        <md-card-media style="text-align: center">
          <br />
          <md-empty-state
            v-if="!ponto.fotos[0]"
            style="width: auto; height: 20vh"
            md-icon="videocam_off"
          />
          <img
            v-if="ponto.fotos[0]"
            style="width: auto; height: 20vh"
            :src="ponto.fotos[0]"
          />
        </md-card-media>

        <md-card-header>
          <div class="md-subheading">Enviado por: {{ ponto.usuarioNome }}</div>
          <div class="md-subheading">
            Criado em:
            {{
              new Date(ponto.horarioCriacao)
                .utcToLocalDate()
                .toLocaleDateString('pt-BR')
            }}
          </div>
        </md-card-header>

        <md-card-expand>
          <md-card-actions md-alignment="space-between">
            <div>
              <md-button class="md-raised md-primary" @click="detalheToCreate">
                Atualizar
              </md-button>
              <md-button
                class="md-primary md-raised"
                @click="detalheToHistorico"
              >
                Histórico
              </md-button>
              <md-button
                class="md-primary md-raised"
                @click.stop="() => createOpenFotosTab(ponto.fotos)"
              >
                Fotos
              </md-button>
            </div>

            <md-card-expand-trigger>
              <md-button class="md-fab md-primary md-mini">
                <md-icon>keyboard_arrow_down</md-icon>
              </md-button>
            </md-card-expand-trigger>
          </md-card-actions>

          <md-card-expand-content>
            <md-card-content>
              <li
                v-for="([chave, data], i) in objectToTuple(
                  ponto.dadosAssociados
                )"
                :key="i"
              >
                {{ compositeName(chave, ponto.tipo) }}: <b>{{ data }}</b>
              </li>
            </md-card-content>
          </md-card-expand-content>
        </md-card-expand>
      </md-card>
      <br />
      <slider-right ref="slider">
        <ListagemFotosSig :fotos="fotosExibicao" />
      </slider-right>
    </div>
  </div>
</template>

<script>
import pontoSigTableNames from '../../../utils/ponto-sig/table.names'
import SliderRight from '../../SliderLeft'
import FormularioPontoSig from '../FormularioPontoSig'
import ListagemFotosSig from '../ListagemFotosSig'
import HistoricoPontosSig from './HistoricoPontosSig'

const state = {
  SHOW_DETALHE: 1,
  SHOW_HISTORICO: 2,
  CREATE: 3,
}

export default {
  name: 'PontoSigDetalhe',
  components: {
    FormularioPontoSig,
    HistoricoPontosSig,
    ListagemFotosSig,
    SliderRight,
  },
  props: {
    ponto: Object,
  },
  data() {
    return {
      fotosExibicao: [],
      state: state.SHOW_DETALHE,
    }
  },
  methods: {
    detalheToHistorico() {
      this.state = state.SHOW_HISTORICO
    },
    detalheToCreate() {
      this.state = state.CREATE
    },
    createToDetalhe() {
      this.state = state.SHOW_DETALHE
    },
    handleFormularioSubmit() {
      this.createToDetalhe()

      this.$emit('change', this.ponto.id)
    },
    historicoToDetalhe() {
      this.state = state.SHOW_DETALHE
    },
    async createOpenFotosTab(fotos) {
      await this.$refs.slider.toogleTab()
      this.fotosExibicao = fotos
    },
    objectToTuple(obj) {
      const mutavel = { ...obj }

      Object.keys(mutavel).forEach((key) => {
        const isOutro = key.substr(key.length - 5) === 'Outro'

        const chaveOriginal = key.substr(0, key.length - 5)

        if (mutavel[chaveOriginal] === 'Outro' && isOutro) {
          mutavel[chaveOriginal] = mutavel[key]
        }

        if (isOutro) {
          delete mutavel[key]
        }
      })

      return Object.keys(mutavel).map((e) => [e, mutavel[e]])
    },
    compositeName(chave, tipo) {
      const tipoString = pontoSigTableNames.tipoPorNumero[tipo]

      return pontoSigTableNames.columns[tipoString][chave]
    },
    isInCurrentState(estado) {
      return this.state === state[estado]
    },
    sairDetalhe() {
      this.$emit('exit')
    },
  },
}
</script>

<style scoped></style>
